import { useQuery } from "@tanstack/react-query";

interface WhoamiLocation {
  displayName: string;
  latitude: number;
  longitude: number;
  countryShortName: string | null;
}

export interface WhoamiEmployment {
  company: string | null;
  title: string | null;
  startDate: { month: number; year: number } | null;
  endDate: { month: number; year: number } | null;
}

export interface WhoamiEducation {
  school?: string | null;
  degree?: string | null;
  discipline?: string | null;
  startMonth?: number | null;
  startYear?: number | null;
  endMonth?: number | null;
  endYear?: number | null;
}

export interface WhoamiSelfIdentification {
  disabilityStatus: number | null;
  gender: number | null;
  race: number | null;
  veteranStatus: number | null;
}

export interface WhoamiProfile {
  id: number;
  status: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  preferredName: string | null;
  location: WhoamiLocation | null;
  employments: WhoamiEmployment[];
  educations: WhoamiEducation[];
  websites: {
    github: string | null;
    linkedin: string | null;
    portfolio: string | null;
    website: string | null;
  };
  resume: { name: string; url: string } | null;
  selfIdentification: WhoamiSelfIdentification | null;
}

const useWhoami = () => {
  return useQuery<WhoamiProfile | null>({
    queryKey: ["whoami"],
    queryFn: async () => {
      const response = await fetch("/users/self", {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Failed to fetch profile");
      return response.json();
    },
    staleTime: 60 * 60 * 1000, // 60 minutes, also invalidated by quick apply form saves
  });
};

export default useWhoami;
